module.exports = __webpack_public_path__ + "img/coreintercomDesk.650b4745.png";